import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import { LOCALES } from "../../../constants";
import { loadData } from "../../../functions/dataLoader";
import FILTERS from "../../../config/filter_config.json";
import SORT_LIST from "../../../config/sort_config.json";

const ATTR_BASIC_SCORE = {
    NUAT_ORDER: 1,
    NUAT_CHAOS: 2,
    NUAT_SUN: 3,
    NUAT_MOON: 4,
    NUAT_STAR: 5,
};

const RARITY_BASIC_SCORE = {
    SR: 1,
    SSR: 2,
};

const normalizeSaviors = (originData, potentials) => {
    const entities = {};
    const ids = [];

    originData.forEach((savior) => {
        ids.push(savior.id);

        const parts = [savior.name[LOCALES.KO], savior.title[LOCALES.KO]];
        const parts_ENG = [savior.name[LOCALES.EN], savior.title[LOCALES.EN]];

        for (const resonance of savior.resonances) {
            if (resonance.potential) {
                const potential = potentials.find((p) => p.str_id === resonance.potential);
                parts.push(potential.name[LOCALES.KO]);
                parts_ENG.push(potential.name[LOCALES.EN]);
            }
        }

        for (const skill of savior.skills) {
            parts.push(skill.name[LOCALES.KO], skill.levels.at(-1).skill_desc[LOCALES.KO]);
            parts_ENG.push(skill.name[LOCALES.EN], skill.levels.at(-1).skill_desc[LOCALES.EN]);
        }

        entities[savior.id] = {
            ...savior,
            searchText: parts.join(" "),
            searchText_ENG: parts_ENG.join(" "),
        };
    });

    ids.sort((a, b) => {
        const diff = RARITY_BASIC_SCORE[entities[b].rank] - RARITY_BASIC_SCORE[entities[a].rank];
        if (diff !== 0) return diff;

        const attrDiff = ATTR_BASIC_SCORE[entities[a].attr] - ATTR_BASIC_SCORE[entities[b].attr];
        if (attrDiff !== 0) return attrDiff;

        const lang = localStorage.getItem("language") || LOCALES.KO;

        return entities[a].name[lang].localeCompare(entities[b].name[lang], lang);
    });

    return { ids, entities };
};

export const initSaviors = createAsyncThunk("saviors/init", async () => {
    const [originData, potentials] = await Promise.all([loadData("saviors.json"), loadData("potentials.json")]);
    const normalized = normalizeSaviors(originData, potentials);
    return normalized;
});

const saviorSlice = createSlice({
    name: "saviors",
    initialState: {
        ids: [],
        entities: {},
        filter: {
            rarity: FILTERS.SAVIOR_RARITY[0],
            attr: FILTERS.ATTRIBUTE[0],
            class: FILTERS.CLASS[0],
            order: SORT_LIST.SAVIOR_SORT[0],
        },
        status: "idle",
    },
    reducers: {
        changeFilter: (state, action) => {
            state.filter[action.payload.id] = action.payload.obj;
        },
    },
    extraReducers: (builder) => {
        builder.addCase(initSaviors.fulfilled, (state, action) => {
            const normalized = action.payload;
            state.ids = normalized.ids;
            state.entities = normalized.entities;
            // state.filter = {
            //     rarity: FILTERS.SAVIOR_RARITY[0],
            //     attr: FILTERS.ATTRIBUTE[0],
            //     class: FILTERS.CLASS[0],
            //     order: SORT_LIST.SAVIOR_SORT[0],
            // };
            state.status = "done";
        });
    },
});

export const { changeFilter } = saviorSlice.actions;
export default saviorSlice.reducer;
